import styled from 'styled-components';
import media from '../../../styles/Media.styled';

export const ButtonContainer = styled.button`
    width: ${({ width }) => width || 'auto'};
    height: ${({ height }) => height || '40px'};
    background-color: ${({ backgroundColor }) => backgroundColor || '#1010EB'};
    border: ${({ border, mouseDown, disabled }) =>
        disabled
            ? border || 'none'
            : mouseDown
            ? '2px solid lightblue'
            : border || 'none'};
    font-family: ${({ fontFamily }) => fontFamily || 'AvenirNextWorld Demi'};
    font-size: ${({ fontSize }) => fontSize || '15px'};
    color: ${({ color }) => color || '#fff'};
    border-radius: ${({ borderRadius }) => borderRadius || '19px'};
    margin: ${({ margin }) => margin || '0'};
    margin-right: ${(props) => props.marginRight};
    padding: ${({ padding }) => padding || '0 12px'};
    justify-content: ${({ justifyContent }) => justifyContent || 'center'};
    align-items: center;
    display: ${({ show }) => (show ? 'flex' : 'none')};
    outline-style: none;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    opacity: ${({ opacity }) => opacity || 1};
    white-space: ${({ WhiteSpace }) => WhiteSpace || 'normal'};
    min-width: ${({ minWidth }) => minWidth || 'unset'};
    box-shadow: ${({ boxShadow }) => boxShadow || 'unset'};
    align-self: ${({ alignSelf }) => alignSelf || ''};

    ${media.mobileDevice`
        width: ${({ mobileWidth, width }) => mobileWidth || width || '100%'};
        height: ${({ mobileHeight, height }) => mobileHeight || height || '40px'};
        margin: ${({ mobileMargin, margin }) => mobileMargin || margin || '0'};
        margin-top: ${({ mobileMarginTop }) => mobileMarginTop || ''};
        margin-bottom: ${({ mobileMarginBottom }) => mobileMarginBottom || ''};
        min-width: ${({ mobileMinWidth, minWidth }) => mobileMinWidth || minWidth || 'unset'};
        border: ${({ mbBorder, border }) => mbBorder || border || 'none'};
        font-size: ${({ fontSizeMobile, fontSize }) => fontSizeMobile || fontSize || '15px'};
        justify-content: ${({ mbJustifyContent, justifyContent }) => mbJustifyContent || justifyContent || 'center'};
        padding: ${({ mbPadding, padding }) => mbPadding || padding || '0 12px'};
    `};

    @media screen and (min-width: 768px) and (max-width: 768px) and (orientation: portrait) {
        width: ${({ ipadWidth }) => ipadWidth || ''};
    }
    @media only screen and (min-width: 820px) and (max-width: 834px) and (orientation: portrait) {
        width: ${({ ipadWidth }) => ipadWidth || ''};
    }
    @media only screen and (min-device-width: 1180px) and (max-device-width: 1180px) and (orientation: landscape) {
        width: ${({ ipadWidth }) => ipadWidth || ''};
    }
    @media only screen and (min-device-width: 667px) and (max-device-width: 1023px) and (orientation: landscape) {
        width: ${({ landscapeWidth }) => landscapeWidth || ''};
        height: ${({ landscapeHeight }) => landscapeHeight || ''};
    }
`;